import { render, staticRenderFns } from "./CompanyListScreen.vue?vue&type=template&id=6079b002&scoped=true&lang=pug"
import script from "./CompanyListScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyListScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyListScreen.vue?vue&type=style&index=0&id=6079b002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079b002",
  null
  
)

export default component.exports